/**
 * The voucher's headline payment method, read from its lines (ML-01).
 *
 * Payment mode is chosen per line, so the header no longer asks for one. It still travels on the
 * request because it is the Payment Method column on the list and the value that list's filter
 * searches on — but it is an observation about the lines, not a second decision.
 *
 * The server settles it either way: `ApPayment.SyncPaymentMethodFromLines()` and its AR twin
 * recompute this on create and update, so whatever is sent here is replaced. It is derived with the
 * same rule rather than left arbitrary so the value the operator sees before saving matches the one
 * that comes back afterwards.
 *
 * One distinct method across the lines is that method; more than one is `Mixed`, which is the
 * honest answer and the one a filter can act on. No lines yet leaves the fallback, since there is
 * nothing to derive from.
 */
export function deriveVoucherPaymentMethod<T extends string>(
  lines: readonly { paymentType: T }[],
  fallback: T,
): T | 'Mixed' {
  const distinct = [...new Set(lines.map(l => l.paymentType))];

  if (distinct.length === 0) return fallback;
  return distinct.length === 1 ? distinct[0] : 'Mixed';
}
